
import { Component, Mixins } from 'vue-property-decorator';
import { TopChannel } from '@/features/dashboard/types';
import Content from '@/features/dashboard/components/widgets/topChannels/Content.vue';
import { WidgetMixin } from '../widgetMixin';

@Component({
  components: {
    Content,
  },
})
export default class TopChannels extends Mixins(WidgetMixin) {
  private channelsShown = 10;

  private channelsShownItems = [5, 10, 15, 20, 25, 30];

  private periodItems: Array<string> = [
    'Last 7 days',
    'Last 30 days',
    'Last 90 days',
    'Last 180 days',
    'Last Year',
    'Custom Range',
  ];

  private period = 'Last 30 days';

  get topChannels(): Array<TopChannel> {
    return this.$store.getters.getTopChannels;
  }
}
